<template>
  <div class="inner-header">
    <div class="title">
      <h3>UEFA Toolkit</h3>
      <transition name="fade" mode="out-in">
        <h1 :key="title" v-text="title"></h1>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: "PageHeader",
  data () {
    return {}
  },
  mounted () {},
  methods: {},
  computed: {
    title () {
      return this.$store.state.headerTitle
    }
  },
}
</script>

<style scoped lang="scss">

h1 {
  font-size: 24px;

  @media all and (min-width: 900px) {
    font-size: 31px;
  }
}

.inner-header {
  max-width: var(--container-width);
  color: #fff;
  padding: 80px 50px 0 15px;
  // max-width: 940px;
  margin: 0 auto;
  display: grid;
  grid-template-areas: 
    "title title"
    "info info";
    
  @media all and (min-width: 1024px) {
    padding: 30px 0;
    grid-template-areas: 
      "title title"
      "description info";
  }
}

h3 {
  font-weight: normal;
  color: #fff;
  font-size: 12px;
}
.title {
  grid-area: title;
  margin-bottom: 2em;
}

</style>